
import Relay from 'react-relay';

export default class AcceptInvitationMutation extends Relay.Mutation {

    getMutation() {
        return Relay.QL`mutation {autoCreateOrganisation}`;
    }

    getVariables() {
        return {};
    }

    getFatQuery() {
        return Relay.QL`
            fragment on AutoCreateOrganisationPayload {
                organisationId
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }
}
